import { useMemo } from "react";

import { useBidListFilters } from "@js/apps/jobs/components/filtering-actions";

export const useBidListFiltersMapped = () => {
  const { filters: bidFilters, areFiltersDefault } = useBidListFilters();

  const bidFiltersMapped = useMemo(() => {
    return {
      ...bidFilters,
      status:
        bidFilters.status && Array.isArray(bidFilters.status)
          ? bidFilters.status.join(",")
          : bidFilters.status,
    };
  }, [bidFilters]);

  return { bidFilters: bidFiltersMapped, areFiltersDefault };
};
